import { Middleware } from 'redux';
import { get } from 'lodash';
import { ROUTE_FILE, ROUTE_TABS, FOLDER_QUERY_PARAM } from '../routing';
import { getUrlFolderId } from '.';

// VE-27161: carry the selected folder into every tab/file route the app
// dispatches without a query of its own. Many places dispatch a bare
// `ROUTE_TABS({ tab })` (tab bar, Files-tab click, search bar, filters, ...).
// Without the folder, each lands on a different URL than the current
// `?folderId=...` one, so redux-first-router pushes a history entry -- the
// Back button then has to step through duplicates -- and the folder sync has to
// re-stamp the URL afterwards.
//
// Must run before the router middleware. Actions coming from browser history
// (Back/Forward) already carry `meta.location.current` and are left alone: the
// URL is what they are restoring.
export const folderQueryMiddleware: Middleware =
  ({ getState }) =>
  (next) =>
  (action: any) => {
    if (
      (action?.type === ROUTE_TABS.type || action?.type === ROUTE_FILE.type) &&
      !get(action, 'meta.location.current') &&
      !get(action, 'payload.query')
    ) {
      const folderId = getUrlFolderId(getState());
      if (folderId) {
        return next({
          ...action,
          payload: {
            ...action.payload,
            query: { [FOLDER_QUERY_PARAM]: folderId },
          },
        });
      }
    }
    return next(action);
  };
